<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="xbigspace">
</p><p class="dedication">Dedicated</p>
<p class="dedication">to</p>
<p class="xxsmallspace">
</p><p class="dedication">MARY QUEEN OF THE HOLY ROSARY</p>
<p class="smallspace">
</p><p class="dedication">Gracious Patroness of the United States</p>
<p class="dedication">in humble petition</p>
<p class="dedication">that</p>
<p class="dedication">through thy Immaculate Heart</p>
<p class="dedication">the world may find its way back to</p>
<p class="dedication">the Sacred Heart of thy Divine Son</p>
<p class="mediumspace">
</p><p class="image"><img alt="imgsecimage.png" src="html/docimages/imgsecimage.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_dedication.vue?70af484a